<template>
  <path
    d="M16.01 11.0002H5C4.45 11.0002 4 11.4502 4 12.0002C4 12.5502 4.45 13.0002 5 13.0002H16.01V14.7902C16.01 15.2402 16.55 15.4602 16.86 15.1402L19.64 12.3502C19.83 12.1502 19.83 11.8402 19.64 11.6402L16.86 8.85019C16.55 8.53019 16.01 8.76018 16.01 9.20018V11.0002Z"
  />
</template>
